import React from 'react';
import './franja.css';

const Franja = () => {

    return (

        <div id="franja" className="franja">
            
            <div className="rectangulo"></div>

            <div className="titulo">

                <h2>Franjas Informativas</h2>

            </div>

            <div className="contenido-seccion">

                <div className="card">

                    <div className="titulo">
                        <h3>31 / Mayo / 2023</h3>
                    </div>

                    <div className="enlace">

                        <a href="https://www.facebook.com/100063543464544/videos/939045647376211/">
                            <img src="./img/franja2.jpeg" alt="img.jpeg"></img>
                        </a>

                    </div>

                </div>

                <div className="card">

                    <div className="titulo">
                        <h3>18 / Mayo / 2023</h3>
                    </div>

                    <div className="enlace">

                        <a href="https://www.facebook.com/100063543464544/videos/929934344908295">
                            <img src="./img/franja3.jpeg" alt="img.jpeg"></img>
                        </a>

                    </div>

                </div>

                <div className="card">

                    <div className="titulo">
                        <h3>17 / Mayo / 2023</h3>
                    </div>

                    <div className="enlace">

                        <a href="https://www.facebook.com/100063543464544/videos/257592920162571">
                            <img src="./img/franja.jpeg" alt="img.jpeg"></img>
                        </a>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default Franja;